function formatSeconds(totalSeconds, format = "hr:min") {
    if (totalSeconds === null || totalSeconds === undefined) return null;

    const totalMinutes = Math.floor(totalSeconds / 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const seconds = Math.floor(totalSeconds % 60); // safer than round here

    switch (format) {
        case "hr:min:sec":
            return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        case "hr:min":
            return hours > 0 ? `${hours}:${minutes.toString().padStart(2, '0')}` : `${minutes} min`;
        case "min:sec":
            return `${totalMinutes}:${seconds.toString().padStart(2, '0')}`;
        default:
            return `${hours} hr ${minutes.toString().padStart(2, '0')} min`;
    }
}


const toDate = (v) => {
  if (!v) return null;
  if (typeof v?.toDate === 'function') return v.toDate();             // Firestore Timestamp
  if (typeof v === 'number') return new Date(v < 1e12 ? v*1000 : v);  // seconds or ms
  if (typeof v === 'string') return new Date(v);                      // ISO
  if (typeof v?._seconds === 'number') return new Date(v._seconds*1000);
  return null;
};

const formatDateTime = (v, opts = { dateStyle: 'medium', timeStyle: 'short' }) => {
  const d = toDate(v);
  return d && !isNaN(d) ? new Intl.DateTimeFormat(undefined, opts).format(d) : '—';
};

export {formatSeconds, formatDateTime}